// src/slices/banks/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getBanks, getBankById, getBankBySlug } from "./thunk";

const initialState = { banks: [], bank: null, loading: false, error: null };

const bankSlice = createSlice({
  name: "bank",
  initialState,
  reducers: {
    clearBankState: (state) => {
      state.bank = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder

      // ================= GET ALL =================
      .addCase(getBanks.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBanks.fulfilled, (state, action) => {
        state.loading = false;
        state.banks = action.payload?.data;
      })
      .addCase(getBanks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= GET BY ID =================
      .addCase(getBankById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBankById.fulfilled, (state, action) => {
        state.loading = false;
        state.bank = action.payload;
      })
      .addCase(getBankById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= GET BY SLUG =================
      .addCase(getBankBySlug.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBankBySlug.fulfilled, (state, action) => {
        state.loading = false;
        state.bank = action.payload;
      })
      .addCase(getBankBySlug.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearBankState } = bankSlice.actions;
export default bankSlice.reducer;
